import { useState } from "react";
import useDealCancelRequest from "../../../../../../../../api/hooks/use-deal-cancel-request";
import ConfirmModal from "../../../../../../../shared/modals/confirmModal";
import TextArea from "../../../../../../../ui/textArea";

interface ICancelDealModal {
  id: number;
  title: string;
  opened: boolean;
  offsetY: number;
  onClose: (value: boolean) => void;
  onRefetch: () => void;
}

const CancelDealModal = ({
  title,
  opened,
  id,
  offsetY,
  onClose,
  onRefetch,
}: ICancelDealModal) => {
  const [comment, setComment] = useState<string>();
  const { data, error, isMutating, trigger } = useDealCancelRequest(id);

  const handleChangeComment = (value: string) => {
    setComment(value);
  };

  const handleCancel = async () => {
    if (id) {
      await trigger({ comment });
      onClose(false);
      onRefetch();
    }
  };

  return (
    <ConfirmModal
      offsetY={offsetY}
      title={"Отменить заявку '" + title + "'"}
      text={"Вы уверены что хотите оменить заявку?"}
      opened={opened}
      onClose={onClose}
      loading={isMutating}
      onClickRight={handleCancel}
    >
      <div style={{ height: 160 }}>
        <TextArea
          value={comment}
          placeholder="Причина: Нашел предложение лучше."
          onChange={handleChangeComment}
        />
      </div>
    </ConfirmModal>
  );
};

export default CancelDealModal;
